<template>
    <div class="homeMainDiv" v-if="webInfo">
        <el-collapse-transition>
            <div class="topBanner" v-if="webInfo.topBannerPic && topBannerShow">
                <el-image class="topBannerPic" :src="globalConfig.filePath + webInfo.topBannerPic" fit="contain"></el-image>
                <p class="topBannerClose" @click="topBannerShow = false;">
                    <i class="el-icon-close"></i>
                    <span>关闭</span>
                </p>
            </div>
        </el-collapse-transition>
        <div class="homgHeader">
            <div class="homgHeaderLeft">
                <div class="webButton">官网</div>
                <div class="homgHeaderName">{{webInfo.schoolName}}</div>
            </div>
        </div>
        <div class="fullLogoAndQrcode">
            <div class="fullLogoList">
                <el-image class="fullLogo" :src="globalConfig.filePath + webInfo.fullLogo1" fit="contain"></el-image>
                <el-image class="fullLogo" :src="globalConfig.filePath + webInfo.fullLogo2" fit="contain"></el-image>
            </div>
            <div class="qrcodeList">
                <div v-for="(item, index) in webInfo.qrcodeList" :key="index" class="qrcodeCard">
                    <el-image class="qrcode" :src="globalConfig.filePath + item.src" fit="contain"></el-image>
                    <div>
                        <span>{{item.name}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="tabsDiv">
            <el-popover placement="bottom" trigger="hover">
                <div>
                    <div class="popoverMajorList" v-for="(item, index) in webInfo.popoverMajor" :key="index">
                        <p>{{item}}</p>
                    </div>
                </div>
                <div slot="reference" class="hotMajorButton">招生热门专业</div>
            </el-popover>
            <div class="tabs">
                <div :class="item.value == activeTabs ? 'tabsItem tabsActice' : 'tabsItem'" v-for="(item, index) in webInfo.tabsList" :key="index" :value="item.value" @click="handleTabsClick(item.value, index)">{{item.label}}</div>
                <div class="tabsActiceBar"></div>
            </div>
        </div>
        <div class="carouselDiv" v-if="activeTabs != 7 && activeTabs != 8">
            <el-carousel indicator-position="inside" :height="carouselHeight">
                <template v-for="(item, index) in webInfo.bannerList">
                    <el-carousel-item :key="index" v-if="item.type == activeTabs">
                        <el-image style="height: 100%;width: 100%;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                    </el-carousel-item>
                </template>
            </el-carousel>
        </div>
        <div class="mainBody">
            <WidgetHome v-if="activeTabs == 1" ref="WidgetHome"></WidgetHome>
            <WidgetSchool v-if="activeTabs == 2" ref="WidgetSchool"></WidgetSchool>
            <WidgetMajor v-if="activeTabs == 3" ref="WidgetMajor"></WidgetMajor>
            <WidgetTeacher v-if="activeTabs == 4" ref="WidgetTeacher"></WidgetTeacher>
            <WidgetFuture v-if="activeTabs == 5" ref="WidgetFuture"></WidgetFuture>
            <WidgetVibes v-if="activeTabs == 6" ref="WidgetVibes"></WidgetVibes>
            <WidgetNews v-if="activeTabs == 7" ref="WidgetNews"></WidgetNews>
        </div>
        <div class="homeFooter">
            <div class="homeFooterList">
                <div style="width: 220px;">
                    <el-divider content-position="center">{{webInfo.footerInfo.qrcode.name}}</el-divider>
                    <el-image style="height: 200px;width: 100%;display: block;" :src="globalConfig.filePath + webInfo.footerInfo.qrcode.src" fit="cover"></el-image>
                </div>
                <el-divider direction="vertical" style="height: 100%;"></el-divider>
                <div style="width: 280px;">
                    <el-divider content-position="center">{{webInfo.footerInfo.enroll.name}}</el-divider>
                    <el-image style="height: 200px;width: 100%;display: block;" :src="globalConfig.filePath + webInfo.footerInfo.enroll.src" fit="cover"></el-image>
                </div>
                <el-divider direction="vertical" style="height: 100%;"></el-divider>
                <div style="width: calc(100% - 500px);">
                    <el-divider content-position="center">升学专业</el-divider>
                    <el-row :gutter="5" class="homeFooterPicList">
                        <el-col :span="4" v-for="(item, index) in webInfo.footerMajorList" :key="index">
                            <el-image style="height: 170px;width: 100%;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                            <div style="height: 30px;width: 100%;text-align: center;background-color: #236de9;line-height: 30px;color: #fff;">{{item.majorName}}</div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div class="pageFooter" :style="'background-image: url(' + globalConfig.filePath + webInfo.pageFooter.bgSrc + ')'">
            <div class="pageFooterInfo">
                <el-image style="height: 100%;margin: 0 20px;" :src="globalConfig.filePath + webInfo.pageFooter.infoSrc1" fit="cover"></el-image>
                <el-image style="height: 100%;margin: 0 20px;" :src="globalConfig.filePath + webInfo.pageFooter.infoSrc2" fit="cover"></el-image>
                <div class="pageFooterInfoContent">
                    <p>
                        <span>{{webInfo.pageFooterInfoContent.schoolName}}</span>
                        <span class="hoverLink" @click="openIPC">{{webInfo.pageFooterInfoContent.ICP}}</span>
                    </p>
                    <p>{{webInfo.pageFooterInfoContent.address}}</p>
                    <p>{{webInfo.pageFooterInfoContent.copyright}}</p>
                </div>
            </div>
        </div>
        <el-backtop></el-backtop>
    </div>
</template>

<script>
    import webInfo from '@/plugin/webInfo.json';

    import WidgetHome from '@/components/Widget/WidgetHome';
    import WidgetSchool from '@/components/Widget/WidgetSchool';
    import WidgetMajor from '@/components/Widget/WidgetMajor';
    import WidgetTeacher from '@/components/Widget/WidgetTeacher';
    import WidgetFuture from '@/components/Widget/WidgetFuture';
    import WidgetVibes from '@/components/Widget/WidgetVibes';
    import WidgetNews from '@/components/Widget/WidgetNews';

    export default {
        components: {
            WidgetHome,
            WidgetSchool,
            WidgetMajor,
            WidgetTeacher,
            WidgetFuture,
            WidgetVibes,
            WidgetNews,
        },
        name: 'Home',
        data() {
            return {
                webInfo: null,
                topBannerShow: true,
                activeTabs: 1,
                carouselHeight: document.body.offsetWidth * (500 / 1920) + 'px',
            };
        },
        mounted() {
            var that = this;
            that.webInfo = webInfo;
            that.handleTabsClick(that.webInfo.tabsList[0].value, 0);
        },
        methods: {
            handleTabsClick(tab, index) {
                this.activeTabs = tab;
                this.$nextTick(() => {
                    this.tabsActiceBarShow(index);
                });
            },
            tabsActiceBarShow(index) {
                var that = this;
                var left = document.querySelectorAll('.tabsItem')[index].offsetLeft;
                var width =
                    document.querySelectorAll('.tabsItem')[index].offsetWidth;
                document.querySelectorAll('.tabsActiceBar')[0].style.left =
                    left + 'px';
                document.querySelectorAll('.tabsActiceBar')[0].style.width =
                    width + 'px';
            },
            openIPC() {
                window.open(
                    'https://beian.miit.gov.cn/?wm=vt1#/Integrated/recordQuery',
                    '_blank'
                );
            },
        },
    };
</script>

<style scoped>
    .topBanner {
        width: 65%;
        margin: 0 auto;
        position: relative;
    }

    .topBannerPic {
        width: 100%;
        height: auto;
        display: block;
    }

    .topBannerClose:hover,
    .topBannerPic:hover + .topBannerClose {
        transform: scale(1);
    }

    .topBannerClose {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 12px;
        line-height: 16px;
        background: #ccc;
        color: #333;
        padding: 0 2px;
        box-sizing: border-box;
        cursor: pointer;
        transition: 0.3s;
        transform: scale(0);
    }

    .homgHeader {
        background: #ccc;
        width: 65%;
        margin: 0 auto;
        height: 40px;
        line-height: 40px;
        box-sizing: border-box;
    }

    .homgHeaderLeft {
        width: 50%;
        display: flex;
    }

    .webButton {
        background: #2a82e4;
        color: #fff;
        padding: 0 10px;
    }

    .homgHeaderName {
        padding: 0 10px;
    }

    .fullLogoAndQrcode {
        width: 65%;
        margin: 0 auto;
        height: 140px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
    }

    .fullLogoList {
        width: 60%;
        height: 140px;
        display: flex;
    }

    .fullLogo {
        height: 140px;
        margin-right: calc(100% * 0.1);
        transition: 0.3s;
    }

    .fullLogo:hover {
        transform: scale(1.02);
    }

    .qrcodeList {
        display: flex;
    }

    .qrcodeCard {
        width: 120px;
        height: 140px;
        text-align: center;
        padding: 10px 0;
        box-sizing: border-box;
        transition: 0.3s;
    }

    .qrcodeCard:hover {
        transform: scale(1.02);
    }

    .qrcode {
        width: 100px;
        height: 100px;
    }

    .tabsDiv {
        width: 65%;
        margin: 0 auto;
        overflow: hidden;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
    }

    .hotMajorButton {
        background: #236de9;
        width: 200px;
        min-width: 200px;
        height: 60px;
        border-radius: 10px 10px 0 0;
        line-height: 60px;
        color: #fff;
        text-align: center;
        font-size: 16px;
    }

    .tabs {
        width: 100%;
        line-height: 60px;
        margin-left: 20px;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        position: relative;
    }

    .tabsItem {
        font-size: 16px;
        margin: 0 5px;
        cursor: pointer;
    }

    .tabsActice {
        color: #236de9;
        font-weight: bold;
    }

    .tabsActiceBar {
        background: #236de9;
        height: 2px;
        width: 0;
        left: 0;
        border-radius: 1px;
        position: absolute;
        bottom: 0;
        transition: 0.3s;
    }

    .carouselDiv >>> .el-carousel__button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #fff;
    }

    .mainBody {
        width: 100%;
    }

    .homeFooter {
        width: 65%;
        height: 285px;
        margin: 0 auto;
        margin-top: 20px;
        display: block;
        padding: 20px;
        border: 1px solid #aaa;
        box-sizing: border-box;
        overflow: hidden;
    }

    .homeFooterList {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
    }

    .homeFooterList .el-divider--vertical {
        height: 100%;
    }

    .homeFooterList .el-divider--horizontal {
        width: 200px;
        margin: 20px auto;
    }

    .homeFooterList .el-divider__text.is-center {
        width: 80px;
    }

    .homeFooterList >>> img {
        transition: 0.3s;
    }

    .homeFooterList >>> img:hover {
        transform: scale(1.1);
    }

    .pageFooter {
        width: 100%;
        height: 200px;
        margin-top: 20px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .pageFooterInfo {
        width: 65%;
        height: 90px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        padding: 55px 20px;
    }

    .pageFooterInfoContent {
        color: #fff;
        line-height: 30px;
        height: 90px;
        margin: 0 20px;
        text-align: center;
        font-size: 16px;
    }

    .popoverMajorList {
        height: 50px;
        font-size: 14px;
        text-align: center;
        width: 100%;
        overflow: hidden;
        line-height: 50px;
    }

    .popoverMajorList + .popoverMajorList {
        border-top: 1px solid #eee;
    }

    .hoverLink {
        margin-left: 10px;
        cursor: pointer;
    }

    .hoverLink:hover {
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue